import { z } from 'zod';
import { nameAndCode, optionalString, requiredString } from './common';
import { genderSchema, parameterFormulaSchema } from './enums';

/** A selectable canned result, e.g. "Positive" / "Negative". */
const parameterResultInputSchema = z.object({
  value: requiredString('Result value'),
});

/** A reference range, optionally scoped to an age/gender cohort. */
const parameterValueInputSchema = z.object({
  normal_range: z.string().trim().default(''),
  unit: z.string().trim().default(''),
  age: optionalString(),
  age_group: optionalString(),
  gender: genderSchema.nullish(),
  other: optionalString(),
});

const testParameterFields = {
  ...nameAndCode,
  /** Null for a typed result. Always sent, so an update can clear it. */
  formula: parameterFormulaSchema.nullable().default(null),
  results: z.array(parameterResultInputSchema).default([]),
  values: z.array(parameterValueInputSchema).min(1, 'Add at least one normal range'),
};

export const createTestParameterSchema = z.object(testParameterFields).refine(
  // A calculated result is a number, never a picked answer.
  (input) => input.formula === null || input.results.length === 0,
  { path: ['results'], message: 'A calculated parameter cannot have preset results' },
);
export type CreateTestParameterInput = z.infer<typeof createTestParameterSchema>;

/** Results and values are replaced wholesale, inside a transaction. */
export const updateTestParameterSchema = createTestParameterSchema;
export type UpdateTestParameterInput = z.infer<typeof updateTestParameterSchema>;
